import React, { useState } from 'react';

import { Popover, Button, Slider, Tooltip, Row, Col, Switch, Modal } from 'antd';
import { appendUTMToURL } from '../../../helpers/utmTracking';

import { QuestionCircleOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCrown, faHatWizard } from '@fortawesome/free-solid-svg-icons';
import { t } from '../../../i18n';

const AdvancedOptions = (props) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleToggleAI = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
    window.open(appendUTMToURL("http://pro.svgtrace.com/signup", "ai-enhancement-modal"));
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <Row>
      {/* ai toggle */}
      <Col style={{ paddingTop: "10px", paddingBottom: "10px", }} span={24}>
        {t("Enhance with AI")} <Tooltip title={t("SvgTrace Pro")}><QuestionCircleOutlined /></Tooltip>
      </Col>
      <Col style={{ paddingBottom: "10px" }}>
        <Switch checked={false} onChange={handleToggleAI} />
        <FontAwesomeIcon icon={faHatWizard} size={14} style={{ paddingLeft: "10px", color: '#e4b301' }} />
      </Col>
      <Col span={24}>{t("Smoothness")} <Slider defaultValue={1} min={0} max={1.34} step={0.01} onChange={(value) => { props.setSmoothness(value) }} /></Col> 
      <Col span={24}>{t("Despeckle")} <Tooltip title={t("Remove small color blobs on the final image by increasing this slider.")}><QuestionCircleOutlined /></Tooltip><Slider defaultValue={props.despeckle} min={0} max={props.imageDimensions[0]/4 > 20 ? props.imageDimensions[0]/4:20} value={props.despeckle} step={1} onChange={(value) => { props.setDespeckle(value) }}  /></Col>
      <Col span={24}>{t("Simplify Curves")} <Tooltip title={t("Increase how round and smooth curves appear with this slider.")}><QuestionCircleOutlined /> </Tooltip> <Slider defaultValue={0.2} min={0} max={1000} onChange={(value) => { props.setSimplifyCurves(value) }} step={0.01} /></Col>
      <Modal
        title={t("Upgrade to Pro for AI Enhancement")}
        visible={isModalVisible}
        okText={t("Upgrade to Pro")}
        cancelText={t("Continue")}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <p>{t("Upgrade to our pro version to access our AI image enhancement feature, which can significantly improve the quality of your images. Are you ready to unlock the full potential of our converter with advanced AI technology?")}</p>
      </Modal>
    </Row>
  );
};

export default AdvancedOptions;